import React, { useEffect, useState } from "react";
import { Download, Share, Plus, X, Smartphone } from "lucide-react";

const isStandalone = () =>
  (typeof window !== "undefined" && window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
  (typeof window !== "undefined" && window.navigator.standalone === true);

const isIOS = () => typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [iosHint, setIosHint] = useState(false);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("ucmp_install_dismissed") === "1");

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", h);
    if (isIOS() && !isStandalone()) setIosHint(true);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  if (isStandalone() || dismissed) return null;
  if (!deferred && !iosHint) return null;

  const dismiss = () => { localStorage.setItem("ucmp_install_dismissed", "1"); setDismissed(true); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  return (
    <div data-testid="install-prompt" className="no-print border-b border-blue-600/25 bg-blue-600/10">
      <div className="px-4 sm:px-8 py-2.5 flex items-center gap-3">
        <Smartphone className="h-4 w-4 text-blue-300 shrink-0" />
        {deferred ? (
          <>
            <span className="flex-1 text-[12px] text-blue-100 leading-snug">
              Install <span className="font-semibold">UC Engineer Pro</span> on your device for one-tap access.
            </span>
            <button onClick={install} data-testid="install-app-btn" className="shrink-0 flex items-center gap-1.5 text-[12px] font-semibold px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white">
              <Download className="h-3.5 w-3.5" /> Install
            </button>
          </>
        ) : (
          <span className="flex-1 text-[12px] text-blue-100 leading-snug flex items-center gap-1 flex-wrap">
            To install, tap <Share className="h-3.5 w-3.5 inline" /> <span className="font-semibold">Share</span> then
            <span className="inline-flex items-center gap-1 font-semibold"><Plus className="h-3.5 w-3.5 inline" /> Add to Home Screen</span>.
          </span>
        )}
        <button onClick={dismiss} data-testid="install-dismiss-btn" aria-label="Dismiss" className="shrink-0 text-blue-300/70 hover:text-white">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
